import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-top: 7rem;
  text-align: center;
  border-radius: ${({ theme }) => theme.borderRadius.main};
  background-color: ${({ theme }) => theme.colors.primary.lighter};
  color: ${({ theme }) => theme.colors.primary.main};
  padding: 64px 0;
  p {
    display: block;
    padding: 2rem 0 3rem;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    margin-top: 2rem;
    padding: 32px 0;
  }
`;
